import React from "react";
import ReactDOM from "react-dom/client"; // Import createRoot from ReactDOM
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { AuthProvider } from './Constant/Auth';
// Get the root DOM element
const container = document.getElementById("root");

// Create a root using ReactDOM.createRoot()
const root = ReactDOM.createRoot(container);

// Render the App component inside the root
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <AuthProvider>
      <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
